import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { xetTotNghiepPhamViSinhVienApi } from "../../../api/xet-tot-nghiep/xetTotNghiepPhamViSinhVienApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eXetTotNghiepPhamViSinhVienActionIds, IXetTotNghiepPhamViSinhVienActionTypes } from "../../action-types/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienActions";
import { IXetTotNghiepPhamViSinhVienSelectRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienSelectRequest";
import { IXetTotNghiepPhamViSinhVienDeleteRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienDeleteRequest";
import { IXetTotNghiepPhamViSinhVienInsertRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienInsertRequest";

const mainActions = rootActions.xetTotNghiep.xetTotNghiepPhamViSinhVien;

export function* xetTotNghiepPhamViSinhVienSaga(): any {
    yield takeLatest(eXetTotNghiepPhamViSinhVienActionIds.LOAD_BY_DOT_XET_START, loadExistDotXetWorker);
    yield takeLatest(eXetTotNghiepPhamViSinhVienActionIds.LOAD_NOT_EXISTS_DOT_XET_START, loadNotExistDotXetWorker);
    yield takeEvery(eXetTotNghiepPhamViSinhVienActionIds.ADD_START, addWorker);
    yield takeEvery(eXetTotNghiepPhamViSinhVienActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eXetTotNghiepPhamViSinhVienActionIds.UPDATE_DUYET_START, updateDuyetWorker);
    yield takeLatest(eXetTotNghiepPhamViSinhVienActionIds.IMPORT_START, importWorker);
}

function* updateDuyetWorker(action: IXetTotNghiepPhamViSinhVienActionTypes): any {
    const payload = action.payload as { id_xet_tot_nghiep: number, id_svs: string[], isduyet: boolean | null };
    let ok = true;
    let message = "";
    for (const id_sv of payload.id_svs) {
        const res: IBaseResponse = yield call(xetTotNghiepPhamViSinhVienApi.UpdateTrangThai, {
            id_xet_tot_nghiep: payload.id_xet_tot_nghiep,
            id_sv,
            isduyet: payload.isduyet,
        });
        if (!res.is_success) {
            ok = false;
            message = res.message ?? "Có lỗi khi cập nhật trạng thái duyệt";
        }
    }
    if (ok) {
        yield put(mainActions.UPDATE_DUYET_SUCCESS(undefined));
    } else {
        yield put(mainActions.UPDATE_DUYET_ERROR(message));
    }
}

function* loadExistDotXetWorker(action: IXetTotNghiepPhamViSinhVienActionTypes) : any {
    const request = action.payload as IXetTotNghiepPhamViSinhVienSelectRequest;
    const response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.SelectExistsDotXet(request);
    if (response.is_success) {
        yield put(mainActions.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_NOT_EXISTS_DOT_XET_ERROR(response.message ?? "Không thể tải dữ liệu đợt xét tốt nghiệp đã thêm"));
    }
}

function* loadNotExistDotXetWorker(action: IXetTotNghiepPhamViSinhVienActionTypes): any {
     const request = action.payload as IXetTotNghiepPhamViSinhVienSelectRequest;
    const response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.SelectNotExistsDotXet(request);
    if (response.is_success) {
        yield put(mainActions.LOAD_NOT_EXISTS_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_NOT_EXISTS_DOT_XET_ERROR(response.message ?? "Không thể tải dữ liệu đợt xét tốt nghiệp chưa thêm"));
    }
}

function* addWorker(action: IXetTotNghiepPhamViSinhVienActionTypes): any {
    const payload = action.payload as IXetTotNghiepPhamViSinhVienInsertRequest;
    let response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.Insert(payload);
    if (response.is_success) {
        yield put(mainActions.ADD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.ADD_ERROR(response.message ?? "Có lỗi khi lưu phạm vi sinh viên xét tốt nghiệp"));
    }
}

function* deleteWorker(action: IXetTotNghiepPhamViSinhVienActionTypes): any {
    const request = action.payload as IXetTotNghiepPhamViSinhVienDeleteRequest;
    const response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.Delete(request);
    if (response.is_success) {
        yield put(mainActions.DELETE_SUCCESS(response.data));
    } else {
        yield put(mainActions.DELETE_ERROR(response.message ?? "Có lỗi khi xóa phạm vi sinh viên xét tốt nghiệp"));
    }
}
function* importWorker(action: IXetTotNghiepPhamViSinhVienActionTypes): any {
    try {
        const { id_xet_tot_nghiep, file } = action.payload as any;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("id_xet_tot_nghiep", id_xet_tot_nghiep.toString());

        const response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.Import(formData);

        if (response.is_success) {
            yield put(mainActions.IMPORT_SUCCESS(toLowerCaseDeep(response.data ?? [])));
        } else {
            yield put(mainActions.IMPORT_ERROR(response.message ?? "Import thất bại"));
        }
    } catch (error: any) {
        yield put(mainActions.IMPORT_ERROR(error.message ?? "Có lỗi khi import"));
    }
}